// Query keys factory for user preferences queries
export const userPreferencesKeys = {
  all: ['userPreferences'] as const,
  lists: () => [...userPreferencesKeys.all, 'list'] as const,
  list: (userId: string) => [...userPreferencesKeys.lists(), userId] as const,
  byCategory: (userId: string, category: string) => 
    [...userPreferencesKeys.list(userId), 'category', category] as const,
};